<script setup>
import {ref, computed} from 'vue'
import IconChevronDown from "@js/components/Icons/IconChevronDown.vue"
import {requisites} from "@js/company_details.ts"

const isOpen = ref(false)
const toggle = () => {
    isOpen.value = !isOpen.value
}

// Маппинг ключей на русские названия
const labels = {
    ogrn: 'ОГРН',
    inn: 'ИНН',
    kpp: 'КПП',
    okpo: 'ОКПО',
    oktao: 'ОКТАО',
    okfs: 'ОКФС',
    oktmo: 'ОКТМО',
    okogu: 'ОКОГУ',
    okopf: 'ОКОПФ',
    registration_data: 'Дата регистрации',
    ur_address: 'Юридический адрес',
    director: 'Руководитель',
}

// Все реквизиты в виде массива объектов с метками и значениями
const allRequisites = computed(() =>
    Object.entries(requisites).map(([key, value]) => ({
        label: labels[key] || key,
        value: value.includes('<') ? value : value.replace(/\n/g, '<br/>')
    }))
)

// первые 5 реквизитов
const initialRequisites = computed(() => allRequisites.value.slice(0, 5))
// остальные реквизиты
const hiddenRequisites = computed(() => allRequisites.value.slice(5))
</script>

<template>
    <div class="w-full">
        <h2 class="container text-xl py-3 border-b">
            Реквизиты компании
        </h2>
        <table class="table-auto w-full text-sm text-left text-gray-500">
            <tbody>
            <!-- Отображаем первые пять -->
            <tr v-for="(item, index) in initialRequisites"
                :key="'initial-' + index"
                :class="(index % 2 === 0 ? 'bg-white' : 'bg-gray-50') + ' border-b'">
                <td class="px-6 py-4 font-medium text-gray-900">{{ item.label }}</td>
                <td class="px-6 py-4" v-html="item.value"></td>
            </tr>
            </tbody>
        </table>

        <!-- Раскрывашка для остальных -->
        <div>
            <button @click="toggle"
                    class="flex items-center justify-center w-full px-6 py-3 bg-gray-100 text-gray-700 rounded-lg focus:outline-none">
                <span>{{ isOpen ? 'Скрыть остальные реквизиты' : 'Показать остальные реквизиты' }}</span>
                <IconChevronDown :class="{'transform rotate-180': isOpen}" class="w-5 h-5 ml-2 transition-transform"/>
            </button>
            <transition name="collapse">
                <div v-show="isOpen" class="overflow-x-auto mt-2">
                    <table class="table-auto w-full text-sm text-left text-gray-500">
                        <tbody>
                        <tr v-for="(item, index) in hiddenRequisites"
                            :key="'hidden-' + index"
                            :class="(index % 2 === 0 ? 'bg-white' : 'bg-gray-50') + ' border-b'">
                            <td class="px-6 py-4 font-medium text-gray-900">{{ item.label }}</td>
                            <td class="px-6 py-4" v-html="item.value"></td>
                        </tr>
                        </tbody>
                    </table>
                </div>
            </transition>
        </div>
    </div>
</template>

<style scoped>
.collapse-enter-active, .collapse-leave-active {
    transition: max-height 0.3s ease;
}

.collapse-enter-from, .collapse-leave-to {
    max-height: 0;
    overflow: hidden;
}

.collapse-enter-to, .collapse-leave-from {
    max-height: 800px;
}
</style>
